// extracted by mini-css-extract-plugin
export default {"pageItemCont":"GotoPageSelection_pageItemCont__N-JN6","pageNumber":"GotoPageSelection_pageNumber__bGiLe"};